import { filterSeasonalMerchandiseProductsByVariantDisplays } from "@/app/(site)/_utils/seasonalMerchandising"
import {
    type GroupedSearchResponse,
    type SearchResponse
} from "@/lib/depict-client/types/api/SearchResponse"
import { formatDepictPrices, transformDepictToProductData } from "./depict-transforms"

export function transformDepictSearchResponse(data: {
    response: any
    locale: string | undefined
    slimVersion: boolean
}): GroupedSearchResponse {
    const { response, slimVersion, locale } = data
    const responseData = response.data as SearchResponse
    let transformedDisplays

    // remove unused fields for slim version
    if (slimVersion) {
        transformedDisplays = responseData.displays.map(display => {
            const transformedVariantDisplays = display.variant_displays.map(variant => {
                const transformedVariant = {
                    size: variant.size,
                    english_title: variant.english_title,
                    transaction_product_id: variant.transaction_product_id,
                    main_product_id: variant.main_product_id,
                    display_id: variant.display_id,
                    color_hex: variant.color_hex,
                    image_urls: variant.image_urls,
                    product_id: variant.product_id,
                    item_group_id: variant.item_group_id,
                    display_item_id: variant.display_item_id,
                    searchable_sku: variant.searchable_sku,
                    title: variant.title,
                    specific_color: variant.specific_color,
                    uri: variant.uri,
                    badge: variant.badge,
                    sale_price: variant.sale_price,
                    original_price: variant.original_price,
                    currency: variant.currency,
                    show_as_sale: variant.show_as_sale,
                    in_stock: variant.in_stock,
                    seasonal_merchandising: variant.seasonal_merchandising
                }

                return transformedVariant
            })
            const transformedDisplay = {
                ...display,
                variant_displays: transformedVariantDisplays
            }
            return transformedDisplay
        })
    } else {
        transformedDisplays = responseData.displays
    }

    const transformedDisplaysData = {
        ...(responseData as SearchResponse),
        displays: transformedDisplays
    }

    // Format prices (also saves numeric values before string formatting)
    // isPlp=false → trims image_urls to 2 for search context
    const withPrices = formatDepictPrices(transformedDisplaysData, undefined)

    const transformedData = {
        ...withPrices,
        n_hits: responseData.n_hits,
        search_request_id: responseData.search_request_id,
        displays: withPrices.displays.map((display: any, idx: number) => ({
            ...display,
            variant_index: display.variant_index ?? idx,
            variant_displays: display.variant_displays ?? [],
            search_result_id: display.search_result_id ?? ""
        }))
    }

    let filteredDisplays = transformedData.displays
    if (locale) {
        filteredDisplays = filterSeasonalMerchandiseProductsByVariantDisplays(
            transformedData.displays,
            locale || ""
        )
    }

    const groupedProducts = transformDepictToProductData(
        {
            ...transformedData,
            displays: filteredDisplays
        },
        "item_group_id"
    )

    return {
        ...transformedData,
        displays: groupedProducts
    }
}
